import {createStore} from 'vuex'

const store = createStore({
	state(){
		return {
			mainMenu:{},
			activeMenuElementId:0,
			positionLeft:'padding-left:0px;',
			activePage:0
		}
	},
	mutations:{
		addMenuItems(state,payload){
			state.mainMenu = payload;
		},
		setMainMenuElementActive(state,payload){
			state.activeMenuElementId = payload.id;
			state.positionLeft = 'padding-left:'+payload.positionLeft+'px';

			for(let i=0;i<state.mainMenu.length;i++){
				const menuItem = state.mainMenu[i];
				if (menuItem.id === payload.id){
					menuItem.active = !menuItem.active

				} else {
					menuItem.active = false;
				}
			}
		},
		activePage(state,payload){
			state.activePage = payload;
		}
	},
	getters:{
		mainMenu(state){
			return state.mainMenu;
		},
		positionLeft(state){
			return state.positionLeft;
		},
		activePage(state){
			return state.activePage;
		}
	},
	actions:{
		loadMenuItems(context) {


			let currentUrl = window.location.protocol +'//' + window.location.hostname;
			console.log('window.location.pathname',window.location.pathname);
			if (window.location.pathname !== '/'){
				currentUrl+='/'+ window.location.pathname;
			}
			//add type information to url
			currentUrl +='/?type=888888888';

			fetch(currentUrl)
				.then((response)=>{
					if (response.ok) {
						return response.json();
					}
				})
				.then((data)=>{
					for (let i=0;i<data.length;i++){
						const element = data[i];
						let activeSubElement = false;
						//check if subelement exist and has status active
						if (element.hasSub){
							for (let x=0;x<element.subMenu.length;x++){
								const subElement = element.subMenu[x];
								if (subElement.current){
									activeSubElement = true;
									break;
								}
							}
						}
						//set current main navigation element as current because one of its sub elements has status current
						if (activeSubElement){
							element.current = true;
						}
					}

					context.commit('addMenuItems',data);
				}
			);

		}
	}
});



export default store;
